import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CONFIG } from '../config/app-config';
import { map } from 'rxjs/operators';
import { EncrDecrService } from './encr-decr.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
	private loggedInStatus = false;

  	constructor(private http: HttpClient, private EncrDecr: EncrDecrService) { }

  	setLoggedIn(value: boolean) {
		this.loggedInStatus = value;  		
  	}

  	get isLoggedIn() {
  		return this.loggedInStatus;
  	}

  	login(email: string, password: string) {
    	return this.http.post<any>(CONFIG.userAuthURL, { email: email, password: password, role: 'ADMIN'})
        .pipe(map(user => {
          if ( user.meta.message_code === "ADMIN_OTP_SENT" ) {
              localStorage.setItem('otpEmail', email);
              localStorage.setItem('otpPassword', password);
          } else {
              // login successful if there's a jwt token in the response
            if (user.data && user.meta && user.meta.status === true) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                const encrypted = this.EncrDecr.set(CONFIG.EncrDecrKey, user.data);
                localStorage.setItem('currentUser', encrypted);
                const firstName = user.data.user_detail.first_name ? user.data.user_detail.first_name : '';
                const lastName = user.data.user_detail.last_name ? user.data.user_detail.last_name : '';
                localStorage.setItem('fullName', firstName + ' ' + lastName);
            }
          }
            return user;
        }));
    }

    forgotPassword(email: string) {
      return this.http.post<any>(CONFIG.forgotPassURL, { email: email, role: 'ADMIN'})
        .pipe(map(response => {
            return response;
        }));
    }

  	logout() {
      	// remove user from local storage to log user out
        localStorage.removeItem('settings');
        localStorage.removeItem('theme');
        localStorage.removeItem ('currentUser');
        localStorage.removeItem ('fullName');
        localStorage.clear();
       
        // remove all modules filter session data
        sessionStorage.clear();
    }
    removeOtpDetails() {
      // Remove OTP email & pass after subadmin login
      localStorage.removeItem ('otpEmail');
      localStorage.removeItem ('otpPassword');
    }

    validateResetPass(token) {
      return this.http.post<any>(CONFIG.validateResetPassURL, { token: token})
      .pipe(map(response => {
          return response;
      }));
    }

    resetPass(token: string, password: string, cPassword: string) {
      return this.http.put<any>(CONFIG.resetPassURL, { new_password: password, confirm_password: cPassword, token: token})
      .pipe(map(response => {
          return response;
      })); 
    }


    getPermissions() {
      let currentUserPermissions = [];
      const decrypted = localStorage.getItem('currentUser');
		  const currentUser = this.EncrDecr.get(CONFIG.EncrDecrKey, decrypted);
      if (currentUser) {
        const currentUserJson = JSON.parse(currentUser);
        currentUserPermissions = currentUserJson.user_detail.permission || [];
      }
      return currentUserPermissions;
    }

    getSubscriptionEndDate(){
      let daysLeft,assignedCredits,remainingCredits;
      let obj = {
        daysLeft:0,
        assignedCredits:0,
        remainingCredits:0
      }
      let user = localStorage.getItem('currentUser');
      const currentUser = this.EncrDecr.get(CONFIG.EncrDecrKey, user);
      if (currentUser) {
        const currentUserJson = JSON.parse(currentUser);
        daysLeft = currentUserJson.user_detail.last_read_at;
        assignedCredits = currentUserJson.user_detail.assigned_credits;
        remainingCredits = currentUserJson.user_detail.remaining_credits;
        obj.daysLeft = daysLeft;
        obj.assignedCredits = assignedCredits;
        obj.remainingCredits = remainingCredits;
      }
      return obj;
    }

    checkRoleSuperAdmin(){
      const decrypted = localStorage.getItem('currentUser');
      const currentUser = this.EncrDecr.get(CONFIG.EncrDecrKey, decrypted);
      const currentUserJSON = JSON.parse(currentUser);
      const checkSuperAdmin = currentUserJSON.user_detail.role;
      let isSuperAdmin:boolean;
      if(checkSuperAdmin === 'SUPER_ADMIN'){
        return isSuperAdmin = true;
      }else{
        return isSuperAdmin = false;
      }
    }

    verifyOTP(data) {
      return this.http.post<any>(CONFIG.verifyOTPURL, data)
        .pipe(map(response => {
          const user = response;
            // login successful if there's a jwt token in the response
            if (user.data && user.meta && user.meta.status === true) {
              this.removeOtpDetails();
              // store user details and jwt token in local storage to keep user logged in between page refreshes
              const encrypted = this.EncrDecr.set(CONFIG.EncrDecrKey, user.data);
              localStorage.setItem('currentUser', encrypted);
              const firstName = user.data.user_detail.first_name ? user.data.user_detail.first_name : '';
              const lastName = user.data.user_detail.last_name ? user.data.user_detail.last_name : '';
              localStorage.setItem('fullName', firstName + ' ' + lastName);
            }
            return response;
        }));
    }
}
